import {useQuery} from 'react-query'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {BASE_URL} from '../../config'
import axios from 'axios'
import {useEffect, useState} from 'react'
import {IMenu} from './_modal'
import {searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import menuListColumn from './menuListColumn'

export const GET_MENU_LIST_URL = `${BASE_URL}/api/protect/getAllMenus`

type Props = {
  searchTerm: string
  onSelectMenu: (menu: IMenu) => void
}

const MenuList = ({searchTerm, onSelectMenu}: Props) => {
  const {
    pagination: {page, totalElement, size},
    handlePageChange,
    handlePagePerItem,
    updatePagination,
  } = usePaginationCounts(1, 10)

  const [menuList, setMenuList] = useState<IMenu[]>([])

  const {isLoading, data, error} = useQuery({
    queryKey: ['menuItemList', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_MENU_LIST_URL, {params: {page, size}})
      const data = await response.data

      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
  })

  const handleSelect = (id: number) => {
    const selected = menuList.find((menu) => menu.id_menu === id)

    if (selected) {
      onSelectMenu(selected)
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof IMenu)[] = ['menu_name']
      const filtered = searchItems(data.list, searchTerm, keys)

      setMenuList(filtered || [])
      updatePagination(data.pagination)
    }
  }, [data, searchTerm])

  return (
    <ListViewProvider isLoading={isLoading} data={menuList}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />
      <>
        <TableContent
          isLoading={isLoading}
          tableData={menuList}
          tableColumn={menuListColumn(handleSelect)}
          error={error as Error}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </>
    </ListViewProvider>
  )
}

export default MenuList
